import { render, staticRenderFns } from "./NewsMaintain.vue?vue&type=template&id=005c123e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./NewsMaintain.vue?vue&type=script&lang=js"
export * from "./NewsMaintain.vue?vue&type=script&lang=js"
import style0 from "./NewsMaintain.vue?vue&type=style&index=0&id=005c123e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c123e",
  null
  
)

export default component.exports